import { render, staticRenderFns } from "./addressPage.vue?vue&type=template&id=e74f9f50&scoped=true"
import script from "./addressPage.vue?vue&type=script&lang=js"
export * from "./addressPage.vue?vue&type=script&lang=js"
import style0 from "./addressPage.vue?vue&type=style&index=0&id=e74f9f50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74f9f50",
  null
  
)

export default component.exports